UIkit.util.ready(function () {

    var url_split   = window.location.href.split('#');

    if (url_split[1] !== undefined) {
        var index       = $('#' + url_split[1]).attr('data-index');

        UIkit.switcher('.partner-switcher').show(index);
    }

});